import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { CampagnePlanificationService, CampagneTypologieService, GlobalDataService } from '@core/services';
import { StringifyOptions } from 'querystring';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-vitesse-distribution',
  templateUrl: './vitesse-distribution.component.html',
  styleUrls: ['./vitesse-distribution.component.scss']
})
export class VitesseDistributionComponent implements OnInit {

  vitesses = ['Classique', 'Rapide'];

  CodeVitesseSub: Subscription;

  constructor(
    public _GlobalDataService: GlobalDataService,
    private _formBuilder: FormBuilder,
    private _datePipe: DatePipe,
    public _CampagnePlanificationService: CampagnePlanificationService,
    private _CampagneTypologieService: CampagneTypologieService,
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.CodeVitesseSub = this._CampagnePlanificationService.form.get('CodeVitesse').valueChanges
      .subscribe((value: string) => {
        // if valid
        if (this._CampagnePlanificationService.form.get('CodeVitesse').valid) {
          // update model
          this._GlobalDataService.Campagne.CodeVitesse = value;
          this._GlobalDataService.Campagne.isDirty = true;

          // FIX 202604 Reselect Produit
          this.updateSelectedProduitByVitesse(value);

          this.init();
        }
      });
  }

  init() {
    console.log(this._GlobalDataService.Campagne.DateRemiseImprimeur);
    if (this._GlobalDataService.isValidDate(this._GlobalDataService.Campagne.DateRemiseImprimeur)) {
      // update model
      let dateTheorique = new Date(this._CampagnePlanificationService.form.get('DateRemiseImprimeur').value);
      if (this._GlobalDataService.Campagne.FrequenceEnvoi == "Classique") {
        dateTheorique.setDate(dateTheorique.getDate() + 12);
      } else {
        dateTheorique.setDate(dateTheorique.getDate() + 7);
      }
      this._GlobalDataService.Campagne.DateTheoriqueDepotLaPoste = this._datePipe.transform(dateTheorique, 'yyyy-MM-dd HH:mm:ss');
      this._CampagnePlanificationService.form.get('DateTheoriqueDepotLaPoste').patchValue(this._datePipe.transform(dateTheorique, 'dd/MM/yyyy'),{ emitEvent: false });


      let dateRetourBAT = new Date();
      dateRetourBAT.setDate(dateTheorique.getDate() + 5);
      let DateEstimeeDistribution = new Date();
      if (this._GlobalDataService.Campagne.FrequenceEnvoi == "Classique") {
        DateEstimeeDistribution.setDate(dateRetourBAT.getDate() + 12);
      } else {
        DateEstimeeDistribution.setDate(dateRetourBAT.getDate() + 7);
      }
      this._CampagnePlanificationService.form.get('DateEstimeeDistribution').patchValue(this._datePipe.transform(DateEstimeeDistribution, 'dd/MM/yyyy'),{ emitEvent: false });

      console.log(this._GlobalDataService.Campagne.DateRemiseImprimeur);
    }
    else {
      this._GlobalDataService.Campagne.DateRemiseImprimeur = 'null'
      this._GlobalDataService.Campagne.DateTheoriqueDepotLaPoste = 'null'
      this._CampagnePlanificationService.form.get('DateTheoriqueDepotLaPoste').patchValue(null,{ emitEvent: false });
      this._CampagnePlanificationService.form.get('DateEstimeeDistribution').patchValue(null,{ emitEvent: false });
    }
  } 

  // checkVitesse(vitesse: string) {
  //   return this._GlobalDataService.CampagneExt.VitessesProduit.indexOf(vitesse) > -1; 
  // }

  /**
   * FIX 202604
   * 
   * Add produit reselection
   */
  private updateSelectedProduitByVitesse(value: string): void {
    console.log('[updateSelectedProduitByVitesse] start');
    console.log('[updateSelectedProduitByVitesse] selected vitesse:', value);
    console.log('[updateSelectedProduitByVitesse] current Campagne before reset:', this._GlobalDataService.Campagne);
    console.log('[updateSelectedProduitByVitesse] current Produit before reset:', this._GlobalDataService.CampagneExt.Produit);

    // Find produit
    const listeProduits = this._CampagneTypologieService.filterProductBySelection(
      this._GlobalDataService.Campagne,
      this._GlobalDataService.produits
    );
    console.log('[updateSelectedProduitByVitesse] listeProduits length:', listeProduits?.length);
    console.log('[updateSelectedProduitByVitesse] listeProduits:', listeProduits);
    const selectedProduit = listeProduits?.find((p: any) => p.Vitesse === value);

    // Reset produit and campagne.IdProduit
    if (selectedProduit) {
      console.log('[updateSelectedProduitByVitesse] matching produit found in find():', selectedProduit);

      this._GlobalDataService.CampagneExt.Produit = selectedProduit;
      this._GlobalDataService.Campagne.IdProduit = selectedProduit.IdProduit;
      console.log('[updateSelectedProduitByVitesse] selected Produit assigned:', this._GlobalDataService.CampagneExt.Produit);
      console.log('[updateSelectedProduitByVitesse] assigned IdProduit:', this._GlobalDataService.Campagne.IdProduit);
    } else {
      console.warn('[updateSelectedProduitByVitesse] no produit found, old values kept');
    }
  }

  ngOnDestroy() {
    if (this.CodeVitesseSub) this.CodeVitesseSub.unsubscribe();
  }

}
